























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel, InspectionEventType } from "@/models/event";

@Component({})
export class Inspection extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;

  get formConfig() {
    return {
      meta: {
        type: {
          label: this.$t("event.fields.type"),
          disabled: this.disabled,
          items: Object.entries(InspectionEventType).map(
            ([key, value]) => ({
              text: this.$t(`event.values.inspectionType.${value}`),
              value
            })
          )
        },
        customType: {
          label: this.$t("event.fields.customType"),
          disabled: this.disabled,
        }
      }
    };
  }
}
export default Inspection;
